module.exports = __webpack_public_path__ + "static/media/18.382b74d4.png";